import { Eyebrow, ArrowLink, Reveal } from "@/components/ui-bits";

const Capacity = () => {
  return (
    <section data-testid="capacity-section" aria-labelledby="capacity-heading" className="bg-[#191c1e] py-16 text-white sm:py-20 lg:py-24">
      <div className="container-30 grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-5">
          <Eyebrow light>Our Transportation Options</Eyebrow>
          <h2
            id="capacity-heading"
            data-testid="capacity-headline"
            className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl"
          >
            CAPACITY WHEN YOU NEED IT.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-white/70 sm:text-lg">
            30 NORTH provides transportation solutions based on your shipment requirements. When additional
            transportation capacity is required, we can arrange transportation through trusted partner carriers and
            manage the shipment from coordination through delivery.
          </p>
          <div className="mt-10">
            <ArrowLink to="/capacity" testid="capacity-cta" light>
              EXPLORE TRANSPORTATION OPTIONS
            </ArrowLink>
          </div>
        </Reveal>

        <Reveal delay={0.12} className="lg:col-span-7">
          <figure className="relative border border-[#2b2f33]" data-testid="capacity-image-frame">
            <img
              src="/assets/tailgate-delivery.webp"
              alt="A 30 NORTH 5-ton straight truck with its hydraulic liftgate lowered during a professional downtown Toronto delivery"
              data-testid="capacity-delivery-image"
              className="aspect-[16/10] w-full object-cover"
              loading="lazy"
            />
            <figcaption
              className="absolute bottom-0 left-0 max-w-full bg-[#191c1e] px-4 py-2 text-[10px] font-bold leading-relaxed tracking-[0.14em] text-white sm:text-[11px] sm:tracking-[0.16em]"
              data-testid="capacity-image-caption"
            >
              5-TON STRAIGHT TRUCK <span className="ml-2 text-[#ff6a00]">+ HYDRAULIC LIFTGATE</span>
            </figcaption>
          </figure>
          <div className="mt-5 grid gap-5 sm:grid-cols-2">
            <div data-testid="carrier-point-contact" className="border border-[#2b2f33] border-l-2 border-l-[#ff6a00] bg-[#121416] p-5">
              <p className="font-display text-base font-bold tracking-wide text-white">ONE POINT OF CONTACT</p>
              <p className="mt-1 text-sm text-white/55">30 NORTH manages your transportation end to end.</p>
            </div>
            <div data-testid="carrier-point-flexible" className="border border-[#2b2f33] border-l-2 border-l-[#ff6a00] bg-[#121416] p-5">
              <p className="font-display text-base font-bold tracking-wide text-white">FLEXIBLE CAPACITY</p>
              <p className="mt-1 text-sm text-white/55">Transportation options that scale with your needs.</p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Capacity;
